import styles from '@components/components/HeatInstallationForm/components/Success/Success.module.scss';
import React from 'react';
import { Button, Heading, Link, Steps } from '@wienenergiegithub/ui-next';

const Success = ({ store }) => {
  const addressPickerLink = store.useValue('addressPickerLink');

  return (
    <div data-purpose="heat-installation-form-success">
      <Heading className={styles.semi} size="h2">
        Vielen Dank! Wie geht es nun weiter?
      </Heading>
      <br />
      <Steps
        items={[
          {
            icon: 'envelope',
            title: 'Sie erhalten eine Anfragebestätigung per E-Mail.',
          },
          {
            icon: 'phone',
            title:
              'Wir rufen Sie an und beraten Sie gerne umfangreich zu Ihrem Fernwärmeanschluss.',
          },
          {
            icon: 'street-view',
            title:
              'Bei Interesse führt ein Techniker eine kostenlose Vor-Ort-Besichtigung durch.',
          },
          {
            icon: 'file',
            title:
              'Danach erhalten Sie ein unverbindliches Angebot mit einer exakten Kostenaufstellung.',
          },
          {
            icon: 'tools',
            title:
              'Los geht’s: In wenigen Tagen ist Fernwärme bei Ihnen installiert und Sie erhalten wohlige Wärme.',
          },
        ]}
        variant="icon"
      />
      <br />
      <Button
        render={<Link to={addressPickerLink}>Zurück zur Fernwärme-Seite</Link>}
      />
    </div>
  );
};

export default Success;
